<template>
    <div>    
        <div class="row">
            <div class="container  pesquisa" >
                <alert :tipo="'alert-danger'" v-if="this.erroMsg != null">{{this.erroMsg}}</alert>
                <form @submit="buscar(), $event.preventDefault()" >
                    <input type="text" v-model="campoCeclam" class="form-control campoPesquisa" placeholder="Digite a NCM ou descrição"/>
                    
                </form>
                <button class="btn btn-primary botaoPesquisa" @click="buscar()">Buscar</button>
                <alert :tipo="'alert-primary'" class="introducao" v-if="this.primeiraVez">
                    Este produto tem o objetivo de auxiliar os profissionais da contabilidade na definição da NCM de produtos, com base em informações prestadas em consultas publicadas pela Receita Federal.<br><br>
                    A pesquisa poderá ser realizada através da descrição ou NCM, caso não exista nenhuma consulta publicada pela Receita Federal a ferramenta não apresentará nenhum resultado para o consulente.
                </alert>
            </div>
        </div>
        <div class="row" v-if="this.primeiraVez == false">
            <div class="container container-fluid">
                <table class="table table-bordered table-hover tabela">
                    <thead>
                        <tr>
                            <th class="tituloTabela" colspan="3" scope="col">Resultado da pesquisa</th>
                        </tr>
                        <tr class="camposTabela">
                            <th>NCM</th>
                            <th>Ementa</th>
                            <th>Legislação/Turma</th>
                        </tr>
                    </thead>
                    <tbody v-if="this.erroMsg == null">
                        <ceclamItem id="ceclamItens" v-for="(item, index) in resultadoPesquisa" :item="item" :key="index"/>
                    </tbody>  
                    <tbody v-if="this.erroMsg == null && this.resultadoPesquisa.length == 0 && this.primeiraVez == false">
                        <td colspan="3">
                            <div class="text-center">
                                <b-spinner variant="primary" label="Text Centered" />
                            </div>
                        </td>
                    </tbody> 
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import alert from '../shared/alert.vue';
import serviceCeclam from '../services/serviceCeclam';
import ceclamItem from './ceclamItem';
import ceclamCodigo from '../models/ceclamCodigo';

export default {
    components:{
        'alert': alert,
        'ceclamItem' : ceclamItem
    },
    data(){
        return{
            campoCeclam:null,
            erroMsg:null,
            resultadoPesquisa:[],
            primeiraVez:true
        }
    },
    methods:{
        buscar(){
            if(this.campoCeclam != null){
                let isNCM = /(\d{4})./;
                let ncmNumeros = /[^\d]+/g;

                this.primeiraVez = false;
                this.resultadoPesquisa = []
                this.erroMsg = null;

                if(isNCM.test(this.campoCeclam)){
                    this.campoCeclam = this.campoCeclam.replace(ncmNumeros, "")                    
                    this.getCodigos();   
                   
                }else{
                    this.getCodigos();
                }
                this.campoCeclam = null
            }else{
                this.erros()
            }
        },
        async getCodigos(){
            this.erroMsg = null
            let res = await serviceCeclam.getCodigos(this.campoCeclam)
            console.log(res.length == 0)
            if(res.length == 0){
                this.erroMsg = 'Nenhum item encontrado'
            }
            if(typeof res != 'string'){
                    res.forEach(element => {
                        this.resultadoPesquisa.push(new ceclamCodigo(element));
                    });
            let footer = 'footer'
            this.$emit('estadoFooter', footer) 
            }else{
                this.erroMsg = res;
            }
        },
        erros(){
            if(this.campoCeclam == null){
                this.erroMsg = 'Campo vazio';
            }
        }
    },
}
</script>
<style scoped>
    .camposTabela{
        text-align: center;
    }
    .colNome{
        width: 19em;
    }
    .tabela{
        position: relative;
        left: 1em;   
    }
    .subTituloTabela{
        font-size: .9em;
        text-align: center;
    }
    .tituloTabela{
        text-align: center;
        font-size: 1.2em;
    }
    .campoPesquisa{
        width: 20rem;
        position: relative;
        /* left:4rem; */
        margin-right:1em;
        height: 2.4em;
    }
    .botaoPesquisa{
        position: relative;
        top: -2.4em;
        left: 20.5rem;
        height: 2.4em;
    }
    .pesquisa{
        margin-top: 3em;
        position: relative;
        left: 1em;
    }
    </style>





// WEBPACK FOOTER //
// src/components/ceclamPesquisa.vue